import { trackEvent } from './segment';
import { extractStudioDesignProductData } from './studio';

export const trackBessieOpened = ({
  design,
  studio,
  packagePrice
}) => {
  trackEvent({
    event: 'bessie_opened',
    properties: {
      ...extractStudioDesignProductData({studio, design}),
      package_price: packagePrice
    }
  });
};
